import { ITicket } from './ITicket';
import { get } from 'lodash';
import { TicketStatus } from '../ticket-status/TicketStatus';
import { TicketPriority } from '../ticket-priority/ticket.priority';

export class ServiceRequestTicket implements ITicket {
  guid: string;
  id: string;
  name: string;
  ticketId: string;
  creationTime: string;
  topicType: string;
  relations: any;
  requestedFor: any;
  stateFinal: string;
  stateId: string;
  main: {
    processId: string;
    company: string;
    status: string;
    shortName: string;
    description: string;
    impact: string;
    receivedTime: string;
    urgency: string;
    priority: string;
    dueDate: string;
    completionDate: string;
    closureCode: string;
    requestedFor: string;
  };
  details: {
    category: string;
    service: string;
    affectedCI: string;
    source: string;
    totalCost: string;
  };

  constructor(
    fromServerTicket: { [key: string]: any },
    statuses: { [key: string]: any },
    priorities: { [key: string]: any }
  ) {
    const customFieldsValuesMap = statuses[fromServerTicket.state.id];
    this.id = fromServerTicket.id;
    this.creationTime = fromServerTicket.creation_time;
    this.guid = fromServerTicket.guid;
    this.ticketId = fromServerTicket.id;
    this.relations = fromServerTicket.relations;
    this.requestedFor = fromServerTicket.relations.find(relation => relation.related_id === fromServerTicket.addressbook);
    this.stateFinal = get(fromServerTicket, 'state.final', null);
    this.stateId = get(fromServerTicket, 'state.id', null);
    this.main = {
      processId: fromServerTicket.guid,
      shortName: fromServerTicket.name,
      description: fromServerTicket.description,
      requestedFor: this.requestedFor ? this.requestedFor.related_record.n_fn : '',
      priority: priorities[fromServerTicket.priority],
      receivedTime: fromServerTicket.received_time,
      company: get(fromServerTicket, 'company.org_name', null),
      status: get(fromServerTicket, 'state.name', null),
      impact: get(fromServerTicket, 'impact.name', null),
      urgency: get(fromServerTicket, 'urgency.name', null),
      closureCode:
        customFieldsValuesMap && customFieldsValuesMap.RequestClosureCode && fromServerTicket.customfields &&
        customFieldsValuesMap.RequestClosureCode[fromServerTicket.customfields.RequestClosureCode],
      dueDate: fromServerTicket.customfields && fromServerTicket.customfields.DueDate ? fromServerTicket.customfields.DueDate : '',
      completionDate: fromServerTicket.customfields && fromServerTicket.customfields.CompletionDate ? fromServerTicket.customfields.CompletionDate : ''
    };
    this.details = {
      affectedCI: get(fromServerTicket, 'ci.name', null),
      source: fromServerTicket.source,
      category: fromServerTicket.category && fromServerTicket.category[0] && fromServerTicket.category[0].name,
      service: get(fromServerTicket, 'service.name', null),
      totalCost: get(fromServerTicket, 'customfields.TotalCost', null)
    };
  }
}
